export class PrematchNavState {
    showMarkets = true;
}
